module.exports = __webpack_public_path__ + "img/gif.66da40e1.png";